import React, { useEffect, useState } from 'react';
import { X } from 'lucide-react';

/*
 * DecisionComposer — record an important planning decision (institutional
 * memory). Decision · what was selected · rationale · owner · date.
 */
function blank() {
  const today = new Date().toISOString().slice(0, 10);
  return { decision: '', selected: '', rationale: '', owner: '', decided_at: today };
}

export default function DecisionComposer({ open, busy = false, onClose, onSubmit }) {
  const [form, setForm] = useState(blank());
  useEffect(() => { if (open) setForm(blank()); }, [open]);
  if (!open) return null;

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    if (!form.decision.trim()) return;
    await onSubmit({
      decision: form.decision.trim(),
      selected: form.selected.trim() || null,
      rationale: form.rationale.trim() || null,
      owner: form.owner.trim() || null,
      decided_at: form.decided_at || null,
    });
  };

  return (
    <div className="ero-modal-scrim" onMouseDown={(e) => { if (e.target === e.currentTarget) onClose?.(); }}>
      <form className="ero-modal" onSubmit={submit} data-testid="decision-composer">
        <button type="button" className="ero-modal-close" onClick={onClose} aria-label="Close"><X size={16} /></button>
        <h3>Record a decision</h3>
        <p className="sub">Preserve the choice and the reasoning so it isn’t re-litigated later.</p>

        <div className="ero-field">
          <label htmlFor="dc-decision">Decision</label>
          <input id="dc-decision" type="text" value={form.decision} onChange={set('decision')}
                 placeholder="e.g. Centerpieces" autoFocus />
        </div>
        <div className="ero-field-row">
          <div className="ero-field">
            <label htmlFor="dc-selected">Selected</label>
            <input id="dc-selected" type="text" value={form.selected} onChange={set('selected')} placeholder="e.g. Rent" />
          </div>
          <div className="ero-field">
            <label htmlFor="dc-date">Date</label>
            <input id="dc-date" type="date" value={form.decided_at} onChange={set('decided_at')} />
          </div>
        </div>
        <div className="ero-field">
          <label htmlFor="dc-rationale">Rationale</label>
          <textarea id="dc-rationale" value={form.rationale} onChange={set('rationale')}
                    placeholder="Why this choice? e.g. Lower cost than purchase." />
        </div>
        <div className="ero-field">
          <label htmlFor="dc-owner">Owner <span style={{ textTransform: 'none', letterSpacing: 0, color: 'var(--ero-ink-4)' }}>(optional)</span></label>
          <input id="dc-owner" type="text" value={form.owner} onChange={set('owner')} placeholder="Who decided?" />
        </div>

        <div className="ero-modal-actions">
          <button type="button" className="ero-btn ghost" onClick={onClose} disabled={busy}>Cancel</button>
          <button type="submit" className="ero-btn primary" disabled={busy || !form.decision.trim()}>
            {busy ? 'Saving…' : 'Record decision'}
          </button>
        </div>
      </form>
    </div>
  );
}
